import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAuditChanges } from '../interfaces/auditchanges';
import { IAuditChangesFilter } from '../interfaces/auditchanges-filter';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class AuditChangesService extends ReadService<IAuditChanges, IAuditChangesFilter> {
  url = '/api/auditchanges';
  entityTitle = 'AuditChanges';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
